const formatPolicies = () => {
  const body = document.querySelector('.shopify-policy__body .rte');
  if (!body || body.dataset.madFormatted || body.querySelector('h2, a')) return;
  const headings = location.pathname.endsWith('/shipping-policy')
    ? ['Physical products', 'Digital delivery', 'Mixed orders']
    : location.pathname.endsWith('/refund-policy')
      ? ['Made-to-order physical products', 'Small-Caterer Quote-to-Prep Kit: 7-day refund option', 'Other digital products', 'Mixed orders and support'] : [];
  let text = body.textContent.trim();
  // The owner may omit the first heading while keeping the same physical-product terms.
  if (location.pathname.endsWith('/refund-policy') && text.startsWith('These terms apply to physical apparel, accessories, and tapestries identified as made to order.')) {
    text = headings[0] + ' ' + text;
  }
  if (!headings.length || !text.startsWith(headings[0])) return;
  const positions = headings.map(h => text.indexOf(h));
  if (positions.some((p,i) => p < 0 || (i && p <= positions[i-1]))) return;
  const fragment = document.createDocumentFragment();
  headings.forEach((heading,i) => {
    const h = document.createElement('h2'); h.textContent = heading;
    const p = document.createElement('p'); p.textContent = text.slice(positions[i]+heading.length,positions[i+1] ?? text.length).trim();
    fragment.append(h,p);
  });
  body.replaceChildren(fragment); body.dataset.madFormatted = 'true';
};
formatPolicies();
